<template>
  <div class="grid-container text-content" @click="isClickingModal = true">
    <div class="info-metadata">
      <b>Lesson {{item.lessonsId}}-{{item.subLessonsId}}</b>
      <p>{{item.name}}<br>{{structure.xp}}<small>XP</small></p>
    </div>
    <hr>
    <div v-html="item.content"/>
  </div>
</template>

<script>
  import LessonsStructure from './LessonsPayload/LessonsStructure'
  import LessonsContent from './LessonsPayload/LessonsContent'

  export default {
    name: 'lessonsText',
    data() {
      return {
        item: null,
        structure: null,
        isInfoOpen: true,
        isClickingModal: false,
      }
    },
    created() {
      const id = parseInt(this.$route.params.id)
      const subId = parseInt(this.$route.params.subId)
      this.item = LessonsContent.filter(item => item.lessonsId === id && item.subLessonsId === subId)[0]
      this.structure = LessonsStructure[id-1].child[subId-1]
    },
  }
</script>

<style lang="scss" scoped>
  .text-content {
    padding: 1rem;
  }

  .info-metadata {
    display: flex;
    justify-content: space-between;
    align-items: center;

    b {
      font-weight: 900;
      font-size: 1.5rem;
      background: linear-gradient(to bottom right, #6f5da8, #1F2041);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }

    p {
      background: linear-gradient(to bottom right, #6f5da8, #1F2041);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      text-align: end;
    }
  }
</style>
